export default __webpack_public_path__ + "static/media/agregar-dinero-cuenta-asociada.43d747ee.png";